export enum DuplicableSectionEnum {
  "Organization",
  "Organization-Company",
  "Organization-TouchPoint",
  "LotResult",
  "LotsGroup",
  "NoticeResult",
  "Procedure-Buyer",
  "Tender",
  "Tenderer",
  "Contract",
  "Lot",
  "Part",
  "UBO"
}
